import dayjs from 'dayjs'

export function toLocal (isoString) {
  return dayjs.utc(isoString).local()
}

export const LOCAL_TZ_ABBR = (() => {
  try {
    return Intl.DateTimeFormat('en-US', { timeZoneName: 'short' })
      .formatToParts(new Date())
      .find(p => p.type === 'timeZoneName')?.value ?? ''
  } catch {
    return ''
  }
})()

export function formatMeetingDate (startDate) {
  if (!startDate) return null
  return toLocal(startDate).format('ddd M/D')
}

export function formatMeetingTime (activity) {
  if (activity.all_day) return 'All day'
  const start = activity.start_date ? toLocal(activity.start_date) : null
  const end = activity.end_date ? toLocal(activity.end_date) : null
  if (!start) return null

  const tzSuffix = LOCAL_TZ_ABBR ? ` ${LOCAL_TZ_ABBR}` : ''

  if (!end) return `${start.format('h:mma')}${tzSuffix}`
  return `${start.format('h:mma')} to ${end.format('h:mma')}${tzSuffix}`
}

export function toDatetimeLocalValue (isoString, allDay) {
  if (!isoString) return ''
  const local = toLocal(isoString)
  return allDay
    ? local.format('YYYY-MM-DD')
    : local.format('YYYY-MM-DDTHH:mm')
}
